module.exports = __webpack_public_path__ + "static/media/Julia_Spevakova.068b323c.jpeg";